import { WbTextField } from '@agilelab/plugin-wb-platform';
import { generateIdentifier } from '@agilelab/plugin-wb-platform-common';
import { useEffect } from 'react';
import { isHidden } from '../../utils';
import { IdentifierPickerProps } from './schema';

export const IdentifierPicker = (props: IdentifierPickerProps) => {
  const {
    onChange,
    schema: {
      title = 'Identifier',
      description = 'Unique identifier of the component',
    },
    required,
    rawErrors,
    formData,
    uiSchema,
    idSchema,
    placeholder,
    formContext,
  } = props;
  const autoFocus = uiSchema['ui:autofocus'];
  const domain = uiSchema['ui:options']?.domainField ?? 'domain';
  const name = uiSchema['ui:options']?.nameField ?? 'name';

  useEffect(() => {
    const id = generateIdentifier(formContext[name], formContext[domain]) ?? '';
    if (formData !== id) onChange(id);
  }, [formContext, formData, domain, name, onChange]);

  return (
    <WbTextField
      id={idSchema?.$id}
      style={{ display: isHidden(uiSchema) ? 'none' : undefined }}
      label={title}
      placeholder={placeholder}
      helperText={description}
      disabled={!(uiSchema['ui:options']?.allowArbitraryValues ?? true)}
      required={required}
      value={formData ?? ''}
      onChange={({ target: { value } }) => onChange(value)}
      margin="normal"
      error={rawErrors?.length > 0 && !formData}
      inputProps={{ autoFocus }}
    />
  );
};
